<template>
  <div class="file-select">
    <div class="search-entity-form">
      <el-input v-model="search" placeholder="输入词、语法、句子、拼音搜索" @change="fetchData" style="width:200px;"/>
    </div>
    <div class="file-select-items">
      <div v-for="(item, key) in results" :key="key" class="file-item" @click="handleClickFile(item)">
        <FilePreview :src="item.url"></FilePreview>
        <div class="file-label">{{item.text}}</div>
      </div>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    ></el-pagination>
  </div>
</template>

<script>
import FilePreview from './FilePreview'

export default {
  name: 'FileSelect',
  props: {
    value: String,
    accept: String,
    prepage: Number
  },
  components: { FilePreview },
  data () {
    return {
      search: '',
      total: 0,
      currentPage: 1,
      pageSize: this.prepage || 20,
      results: [],
    }
  },
  computed: {
    fetchUrl () {
      if (/image/.test(this.accept)) {
        return this.$urls.filemanager_images
      }
      if (/audio/.test(this.accept)) {
        return this.$urls.filemanager_audios
      }
      return ''
    }
  },
  methods: {
    fetchData () {
      if (!this.fetchUrl) return
      this.$http.get(this.fetchUrl, {
        params: {
          keywords: this.keyword,
          page: this.currentPage,
          'per-page': this.pageSize,
          'wd': this.search,
        }
      }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.results = res.data
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleClickFile(file) {
      this.$emit('input', file.url)
    }
  }
}
</script>

<style lang="scss">
  .file-select{
    .search-entity-form{
      padding-bottom: 10px;
    }
    .file-label{
      text-align: center;
    }
    .file-item{
      &:hover{
        background-color: #eef5fe;
      }
    }
  }
  .file-select-items{
    max-height: 600px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    grid-gap: 8px;
  }
</style>